import http from "../utils/http-common";

class LtrCalculationService {
  getAll(params) {
    return http.get("/ltr-calculations", { params });
  }

  get(id) {
    return http.get(`/ltr-calculations/${id}`);
  }

  create(data) {
    return http.post("/ltr-calculations", data);
  }

  update(id, data) {
    return http.put(`/ltr-calculations/${id}`, data);
  }

  delete(id) {
    return http.delete(`/ltr-calculations/${id}`);
  }
}

export default new LtrCalculationService();
